export const BASE_NAME = 'Altihex'
const URL:any = {
  dev: 'https://t1-altihex-service.shizhuang-inc.com',
  t1: 'https://t1-altihex-service.shizhuang-inc.com',
  d1: 'https://d1-altihex-service.shizhuang-inc.com',
  prod: 'https://altihex-service.shizhuang-inc.com',
}
const env: string = process.env.ENV || 't1' as string
export const BASE_API = URL[env] + '/api/public'
export const DEFAULT_CONFIG = {
  rootComponent: null,
  root: '#app',
  mount: true,
  preivew: false,
  cbLogin: (res: any) => res,
  update: (res: any) => res, 
  headers: {},
  page: {},
}
